import { Card, CardContent, CardHeader, Divider, Grid, Stack, Typography } from '@mui/material';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import React, { useEffect, useState } from 'react';
import { micService } from 'services/mic';
import { getProduct, handleAsyncCall, toDefaultDateFormat } from 'utils/common';
import BCBarChart from './bc-bar-chart';
import _ from 'lodash';

const Home = () => {
  const { t, useNavigate, useLocation, dispatch, useSelector, project, upperCaseLang } = useMain();
  const [contractList, setContractList] = useState([]);
  const [bcStats, setBcStats] = useState({});
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const navigate = useNavigate();
  const product = getProduct()?.Id;
  useEffect(() => {
    const fetchStats = async () => {
      const statObj = {};
      for (const bctype of bcTypes) {
        const res = await handleAsyncCall({
          service: micService.getBcStats,
          params: {
            projid: project?.ProjId,
            bctype: bctype.Bctype
          }
        });
        statObj[bctype.Bctype] = res;
      }
      setBcStats(statObj);
    };

    if (!_.isEmpty(bcTypes) && project?.ProjId) {
      fetchStats();
    }
  }, [bcTypes, project?.ProjId]);

  useEffect(() => {
    if (project?.ProjId) {
      handleAsyncCall({
        service: micService.getContractList,
        params: {
          projid: project?.ProjId
        },
        successCb: (res) => {
          setContractList(res.data);
        }
      });
    }
  }, [project?.ProjId]);

  useEffect(() => {
    if (!project?.ProjId) {
      navigate('/project');
    }
    if (!product) {
      navigate('/product');
    }
  }, [project?.ProjId, product]);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MainCard content={false}>
          <CardContent>
            {contractList.map((object, i) => {
              const SharedGridItem = (title, text) => (
                <Grid item xs={6} md={2}>
                  <Stack direction="row" justifyContent="space-between">
                    <Stack direction="column">
                      <Typography variant="h5" sx={{ color: '#bfbfbf' }}>
                        {title}
                      </Typography>
                      <Typography variant="body1">{text}</Typography>
                    </Stack>
                    {!_.isEqual(t('END_DATE'), title) && (
                      <Stack>
                        <Divider orientation="vertical" />
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              );

              return (
                <Grid key={`contract-${i}`} container spacing={2} justifyContent="space-between">
                  {SharedGridItem(t('CONTRACT_NO'), object.ContractNo)}
                  {SharedGridItem(t('CONTRACTOR'), object[`ContractorName${upperCaseLang}`])}
                  {SharedGridItem(t('DESC'), object[`ContractDesc${upperCaseLang}`])}
                  {SharedGridItem(t('START_DATE'), toDefaultDateFormat(object[`ContractStartDate`]))}
                  {SharedGridItem(t('END_DATE'), toDefaultDateFormat(object[`ContractEndDate`]))}
                </Grid>
              );
            })}
          </CardContent>
        </MainCard>
      </Grid>

      {Object.entries(bcStats).map(([key, value], i) => (
        <Grid key={`${key}-BarChart`} item xs={12} md={6} lg={6}>
          <MainCard title={_.isEmpty(bcTypes[i]) ? '' : bcTypes[i][`Desc${upperCaseLang}`]}>
            <BCBarChart stat={value} />
          </MainCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default Home;
